/** Client-side typewriter reveal — gives a live “generating” feel for rule-based replies. */

export function startStreamReveal(messageId, fullText, setMessages, options = {}) {
  const text = String(fullText || "");
  if (!text || !messageId || typeof setMessages !== "function") {
    return () => {};
  }

  const minLength = options.minLength ?? 28;
  if (text.length < minLength) {
    setMessages((prev) =>
      prev.map((m) =>
        m.id === messageId ? { ...m, content: text, isStreaming: false, streamFull: undefined } : m
      )
    );
    return () => {};
  }

  const parts = text.match(/\S+\s*/g) || [text];
  const durationMs = options.durationMs ?? 2400;
  const stepMs = Math.max(14, Math.min(36, durationMs / parts.length));
  let idx = 0;
  let timer = null;

  const tick = () => {
    idx += 1;
    const partial = parts.slice(0, idx).join("");
    const done = idx >= parts.length;
    setMessages((prev) =>
      prev.map((m) =>
        m.id === messageId
          ? { ...m, content: partial, isStreaming: !done, streamFull: done ? undefined : text }
          : m
      )
    );
    if (!done) {
      timer = setTimeout(tick, stepMs);
    }
  };

  timer = setTimeout(tick, stepMs);
  return () => {
    if (timer) clearTimeout(timer);
  };
}

/** Prepare a message for stream reveal (cards/profile show; text fills in). */
export function prepareStreamMessage(message) {
  if (!message?.content?.trim() || message.llmPending) return message;
  return {
    ...message,
    content: "",
    isStreaming: true,
    streamFull: message.content,
  };
}
